import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {

  @ViewChild('reportSummaryTable', { static: true })
  public reportSummaryTable: Table;

  public reportSummaryTableData: any = [];
  public userID: any;
  public subjectSub: any;
  public selectedYear: any;

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.loadDataAndApplyFilter();
  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.dashboardSummaryReport(this.selectedYear);
      }
    );
  }

  dashboardSummaryReport(selectedYear: any){
    this.loader.start();
    this.deptDashBoardService
      .dashboardSummaryReport(this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Application Abstract Report', '', new Date(), 'Success');
          this.reportSummaryTableData = res;
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Application Abstract Report', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

}
